import { render } from "./BoisDeChauffage.vue?vue&type=template&id=72234c97"
import script from "./BoisDeChauffage.vue?vue&type=script&lang=js"
export * from "./BoisDeChauffage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__